// This file is AUTOGENERATED, do not edit it manually!!!

export const koPeopleTemplates = {
    nomatch_text: 'Désolé, rien n\'a été trouvé',
    roles: 'Rôles',
    teams: 'Équipes',
    users: 'Utilisateurs',
};
